import BoxWithDarkGreyFill from 'components/common/Box/BoxWithDarkGreyFill';
import React, { ReactNode } from 'react';
import { extendClassName } from 'utils/common';

interface ISelectableBoxWithOutline {
  additionalClassName: string;
  children: ReactNode;
  centerHorizontal?: boolean;
  centerVertical?: boolean;
  customTextColor?: string;
  noBorder?: boolean;
  outlineWhenSelected?: boolean;
  onClick?: () => void;
  selected?: boolean;
  useDefaultPadding?: boolean;
  styles: React.CSSProperties;
}
const SelectableBoxWithOutline = ({
  additionalClassName,
  children,
  centerHorizontal = false,
  centerVertical = false,
  customTextColor,
  noBorder = false,
  outlineWhenSelected = false,
  onClick,
  selected = false,
  useDefaultPadding = false,
  styles,
}: ISelectableBoxWithOutline) => {
  if (selected) {
    return (
      <BoxWithDarkGreyFill
        onClick={onClick}
        additionalClassName={additionalClassName}
        outline={outlineWhenSelected}
        centerHorizontal={centerHorizontal}
        centerVertical={centerVertical}
      >
        {children}
      </BoxWithDarkGreyFill>
    );
  }

  return (
    <div
      className={extendClassName('boxWithOutline', [
        centerHorizontal ? 'text-centered' : '',
        centerVertical ? 'flexCentered' : '',
        !noBorder ? 'greyOutlineBox' : '',
        onClick ? 'clickable' : '',
        additionalClassName,
      ])}
      onClick={onClick}
      style={styles}
    >
      {children}

      <style jsx>
        {`
          .boxWithOutline {
            ${customTextColor ? `color: ${customTextColor};` : ''}
            ${useDefaultPadding ? 'padding: 2.25em max(1.5em, 5%);' : ''}
          }

          .greyOutlineBox {
            border: 3px solid #e1e1e1;
            border-radius: 12px;
          }
        `}
      </style>
    </div>
  );
};

export default SelectableBoxWithOutline;
